import React, { useEffect, useState } from 'react';
import { MdOutlineRadioButtonUnchecked } from 'react-icons/md';
import {
  RiProgress1Line,
  RiProgress2Line,
  RiProgress3Line,
  RiProgress4Line,
  RiProgress5Line,
  RiProgress6Line,
  RiProgress7Line,
} from 'react-icons/ri';

interface CourseDataProps {
  courseData: any;
}

const MAX_CHECKMARK_POINT = 7;

const CourseCompletionCheckMark: React.FC<CourseDataProps> = ({ courseData }) => {
  const [overallCompletion, setOverallCompletion] = useState<number>(0);
  const [overallCompletionLoaded, setOverallCompletionLoaded] = useState<boolean>(false);

  const handleCheckSubUnitCompletion = () => {
    if (Array.isArray(courseData?.children) && courseData?.children.length > 0) {
      const totalSubUnits = courseData?.children.length;
      const totalScore = courseData.children.reduce((accumulator: number, current: { completion?: number }) => (
        accumulator + (current?.completion ?? 0)
      ), 0);
      setOverallCompletion(Math.round((totalScore * MAX_CHECKMARK_POINT) / totalSubUnits));
      setOverallCompletionLoaded(true);
    }
  };

  useEffect(() => {
    handleCheckSubUnitCompletion();
  }, []);

  return (
    overallCompletionLoaded && overallCompletion > 0 ? (
      <>
        {
          overallCompletion === 1 && (
            // @ts-ignore
            <RiProgress1Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 2 && (
            // @ts-ignore
            <RiProgress2Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 3 && (
            // @ts-ignore
            <RiProgress3Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 4 && (
            // @ts-ignore
            <RiProgress4Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 5 && (
            // @ts-ignore
            <RiProgress5Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 6 && (
            // @ts-ignore
            <RiProgress6Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
        {
          overallCompletion === 7 && (
            // @ts-ignore
            <RiProgress7Line color="#0A3887" size={17} style={{ minWidth: '17px' }} />
          )
        }
      </>
    ) : (
      // @ts-ignore
      <MdOutlineRadioButtonUnchecked color="#0A3887" size={17} style={{ minWidth: '17px' }} />
    )
  );
};

export default CourseCompletionCheckMark;
